import { findLesson } from "./_helpers";
import { LessonShell } from "@/components/LessonShell";
import { RomanNumeralAnalysis } from "@/components/song/RomanNumeralAnalysis";
import { YouTubeEmbed } from "@/components/song/YouTubeEmbed";
import { NoteImage } from "@/components/mt/NoteImage";
import { Section } from "@/components/Section";
import { KeyIdea } from "@/components/Callouts";

export default function EdSheeran7() {
  const { lesson, course, accent } = findLesson("ed-sheeran", "7");
  return (
    <LessonShell
      course={course}
      courseSlug="ed-sheeran"
      lessonOrder={lesson.order}
      title={lesson.title}
      description={lesson.desc}
      videoUrl={lesson.video}
      thumbUrl={lesson.thumb}
      accent={accent}
    >
      <Section title="Chord Chart">
        <NoteImage
          src="/notes/ed-sheeran/finals/07-in-other-words.png"
          caption="Jason's chord chart for In Other Words"
        />
      </Section>

      <Section title="The Main Progression">
        <RomanNumeralAnalysis
          label="Verse · G major"
          chords={[
            { chord: "G", rn: "I", function: "Tonic", pitches: ["G2", "B2", "D3", "G3"] },
            { chord: "D", rn: "V", function: "Dominant", pitches: ["D3", "F#3", "A3", "D4"] },
            { bar: true },
            { chord: "Em7", rn: "vi7", function: "Submediant", pitches: ["E3", "G3", "B3", "D4"] },
            { chord: "C", rn: "IV", function: "Pre-dominant", pitches: ["C3", "E3", "G3", "C4"] },
          ]}
        />
        <KeyIdea title="A familiar loop">
          I–V–vi–IV is one of the most familiar progressions in pop. Once you know it, you start
          hearing it everywhere.
        </KeyIdea>
      </Section>

      <Section title="Bridge — Chromatic Walk">
        <RomanNumeralAnalysis
          label="Bridge · G major"
          chords={[
            { chord: "D", rn: "V", function: "Dominant", pitches: ["D3", "F#3", "A3", "D4"] },
            { chord: "B/D#", rn: "V⁶/vi", function: "Secondary V", pitches: ["D#2", "B2", "D#3", "F#3"] },
            { bar: true },
            { chord: "Em", rn: "vi", function: "Submediant", pitches: ["E3", "G3", "B3", "E4"] },
            { chord: "D", rn: "V", function: "Dominant", pitches: ["D3", "F#3", "A3", "D4"] },
            { chord: "C", rn: "IV", function: "Pre-dominant", pitches: ["C3", "E3", "G3", "C4"] },
            { bar: true },
            { chord: "Cm7", rn: "iv7", function: "Borrowed", pitches: ["C3", "Eb3", "G3", "Bb3"] },
            { chord: "Cm6", rn: "iv6", function: "Borrowed", pitches: ["C3", "Eb3", "G3", "A3"] },
            { bar: true },
            { chord: "D", rn: "V", function: "Dominant", pitches: ["D3", "F#3", "A3", "D4"] },
          ]}
        />
        <KeyIdea title="Special moment">
          B/D♯ is the V of Em (B major) with D♯ in the bass, so the bass climbs D → D♯ → E in half
          steps into Em. Then the bridge borrows Cm7 and Cm6 from G minor — that E♭ is the
          darker colour just before D leads home.
        </KeyIdea>
      </Section>

      <Section title="Watch">
        <YouTubeEmbed videoId="i752DxeIi7Q" />
      </Section>
    </LessonShell>
  );
}
